export const TIME_PARAM_NAMES = [
  "MaximumJourneyTime",
  "MinimumJourneyTime",
  "MaximumChangeTime",
  "MinimumChangeTime",
  "MaximumConnectionTime",
  "MinimumConnectionTime",
  "MaximumLongestSegmentTime",
  "MinimumLongestSegmentTime",
];
